import React, { useEffect, useMemo } from 'react'
import { ListItem, Box, ListItemButton, Divider } from "@mui/material"
import useVisibility from "../../../utils/isVisible"
import { CircularProgress } from "@mui/material"
import ConversationItem from "../../Chat/ConversationList/ConversationItem"


const FinishedRow = ({ parent, isVisibleHook = () => {}, shouldAlwaysCheck = false, data, onClickItem, activeChat, isManageCalls, style, version, onCtrlClickItem = () => {}, selectedChats = [] }) => {
    const [isVisible, currentElement, calcVisibility] = useVisibility(100, 100, parent)

    useEffect(() => {
        //isVisibleHook(isVisible)
        calcVisibility()
    }, [])

    if (shouldAlwaysCheck) {
        useEffect(() => {
            isVisibleHook(isVisible)
        }, [isVisible])
    }

    const active = activeChat?.uniqueid === data.uniqueid
    const selected = selectedChats.some((c) => c.id === data.id)

    const memoItem = useMemo(() => {
        return (
            <ConversationItem
                key={`${data.id}-conversation-item`}
                onClick={() => { onClickItem(data); }}
                onCtrlClick={() => onCtrlClickItem(data)}
                showProgressTime={false}
                activeId={activeChat?.uniqueid}
                conversation={data}
                isManageCalls={isManageCalls ? true : false}
                setReadMessages={() => { }}
                forceActive={active}
                selected={selected}
                version={version}
            />
        )
    }, [data, active])

    return (
        <ListItem
            component="div"
            ref={currentElement}
            style={style}
            disablePadding={(version) !== "manageCalls" ? true : false}
            sx={{ padding: (version) !== "manageCalls" ? 0 : "4px 8px" }}
        >
            <ListItemButton sx={{ padding: 0, "&:hover": { backgroundColor: (version === "manageCalls") ? "transparent" : "#f2f4f6" }}}>
                <Box key={`${data.id}-key-on-queue`} sx={{ width: "100%", height: "100%" }}>
                    {(isVisible && data.id > 0) ?
                        <>
                           { memoItem }
                        </>
                        :
                        <Box className={'loader-skeleton'}
                            sx={{ height: '100px', justifyContent: "center" }}
                        >
                            <CircularProgress />
                        </Box>
                    }
                    {version !== "manageCalls" && <Divider />}
                </Box>
            </ListItemButton >
        </ListItem>

    )
}

export default FinishedRow